import { AutoCompleteOptions } from '../../interfaces/options';
import { AutoCompleteOperator } from '../../enums';
import { Templates } from '../../compile';

export const DefaultAutoCompleteOptions: AutoCompleteOptions<any> = {
	list: null,
	filterKey: null,
	uiElement: {
		widget: {
			widget: Templates.widgets_autocomplete
		}
	},
	comparer: [
		AutoCompleteOperator.IndexOfCaseSensitive,
		AutoCompleteOperator.IndexOfCaseInSensitive,
		AutoCompleteOperator.Length
	],
	severFilter: false,
	serverSort: false,
	showList: true,
	delay: null
};
